// チャット内の絵文字リアクションをしたユーザー一覧を表示するボトムメニュー

import defaultUserIcon from '@src/assets/images/avatar/default.png';
import { ChannelMemberUserTypeEnum } from '@src/enum/ChannelMemberUserTypeEnum';
import { Emoji } from 'emoji-picker-react';
import React, { useEffect, useRef, useState } from 'react';

import SpBottomMenuLayout from './SpBottomMenuLayout';

interface ReactionUserBottomMenuProps {
  handleCloseClick: () => void;
  initPositionY?: string;
  users?: {
    user_id?: number;
    display_name?: string;
    avatar_url?: string;
    user_type?: ChannelMemberUserTypeEnum;
  }[];
  emoji?: string;
}

const ReactionUserBottomMenu: React.FC<ReactionUserBottomMenuProps> = ({
  handleCloseClick,
  initPositionY = '324px',
  users,
  emoji,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const headerRef = useRef<HTMLDivElement>(null);
  const [scrollAreaHeight, setScrollAreaHeight] = useState<number>();

  // 親要素の高さが変更された時にスクロール領域の高さを再計算
  useEffect(() => {
    const updateScrollAreaHeight = () => {
      if (containerRef.current && headerRef.current) {
        const bottomMenuElement = containerRef.current.closest('.fixed.bottom-0');
        if (!bottomMenuElement) {
          return;
        }
        const menuHeight = bottomMenuElement.clientHeight;
        const headerHeight = headerRef.current.clientHeight;
        const availableHeight = menuHeight - headerHeight;
        setScrollAreaHeight(availableHeight);
      }
    };

    // 少し遅延させて初期計算（レイアウトが安定してから）
    const timeoutId = setTimeout(updateScrollAreaHeight, 200);

    // ResizeObserverで親要素の高さ変更を監視
    const resizeObserver = new ResizeObserver(updateScrollAreaHeight);
    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);

      // SpBottomMenuLayoutのコンテナも監視
      const bottomMenuElement = containerRef.current.closest('.fixed.bottom-0');
      if (bottomMenuElement) {
        resizeObserver.observe(bottomMenuElement);
      }
    }

    return () => {
      clearTimeout(timeoutId);
      resizeObserver.disconnect();
    };
  }, []);
  return (
    <SpBottomMenuLayout
      handleCloseClick={handleCloseClick}
      isSwipeAfter={isExpanded}
      onSwipeDown={() => {
        if (isExpanded) {
          setIsExpanded(false);
        } else {
          handleCloseClick();
        }
      }}
      initPositionY={initPositionY}
    >
      <div
        ref={containerRef}
        className={`flex min-h-[262px] flex-col overflow-hidden`}
        data-testid='reaction-user-bottom-menu'
      >
        <div
          ref={headerRef}
          className='flex shrink-0 justify-center p-2 text-sm'
        >
          <Emoji
            unified={emoji?.toLowerCase() || ''}
            size={24}
          />
        </div>
        <div
          className='overflow-y-auto border-t border-solid border-gray-200'
          style={{
            height: `${scrollAreaHeight}px`,
            maxHeight: `${scrollAreaHeight}px`,
          }}
        >
          <div className='flex flex-col gap-1 py-2.5 pb-8'>
            {users?.map((user) => (
              <div
                className='flex items-center gap-4 truncate px-8 py-[2px]'
                key={user?.user_id}
              >
                <img
                  src={user?.avatar_url ?? ''}
                  onError={(e) => {
                    e.currentTarget.src = defaultUserIcon;
                  }}
                  alt={user?.display_name}
                  className='size-[28px] rounded-full object-cover'
                />
                <span className='truncate text-sm'>{user?.display_name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </SpBottomMenuLayout>
  );
};

export default ReactionUserBottomMenu;
